/**
 * バリアントドロップダウン（detailsタグベース）
 *
 * detailsタグを利用したカスタムセレクター。
 * 選択肢のクリック→UI更新→カスタムイベント発火で外部と連携する。
 */
(function () {
  'use strict';

  /**
   * ドロップダウンの初期化
   * @param {HTMLElement} dropdown_el - .cm-variant-dropdown 要素
   */
  function initDropdown(dropdown_el) {
    const details_el = dropdown_el.querySelector('.cm-variant-dropdown__details');
    const summary_el = dropdown_el.querySelector('.cm-variant-dropdown__summary');
    const list_el = dropdown_el.querySelector('.cm-variant-dropdown__list');
    if (!details_el || !summary_el || !list_el) return;

    const items = list_el.querySelectorAll('.cm-variant-dropdown__item');

    // 選択肢クリック処理
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        selectItem(dropdown_el, details_el, summary_el, items, item);
      });

      // Enterキーでも選択可能にする
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectItem(dropdown_el, details_el, summary_el, items, item);
        }
      });
    });

    // detailsが開いたとき外側クリックで閉じる
    details_el.addEventListener('toggle', function () {
      if (details_el.open) {
        // 次のフレームでリスナーを追加（summaryクリックが伝播しないように）
        requestAnimationFrame(function () {
          document.addEventListener('click', handleOutsideClick);
        });
      } else {
        document.removeEventListener('click', handleOutsideClick);
      }
    });

    /**
     * 外側クリックで閉じる処理
     */
    function handleOutsideClick(event) {
      if (!details_el.contains(event.target)) {
        details_el.removeAttribute('open');
        document.removeEventListener('click', handleOutsideClick);
      }
    }
  }

  /**
   * 選択肢の選択処理
   */
  function selectItem(dropdown_el, details_el, summary_el, items, selected_item) {
    const value = selected_item.dataset.value;
    const variant_id = selected_item.dataset.variantId;
    const is_available = selected_item.dataset.available === 'true';

    // チェックマークの更新
    items.forEach(function (item) {
      const check_el = item.querySelector('.cm-variant-dropdown__check');
      if (item === selected_item) {
        item.classList.add('cm-variant-dropdown__item--selected');
        item.setAttribute('aria-selected', 'true');
        if (check_el) check_el.classList.remove('cm-variant-dropdown__check--hidden');
      } else {
        item.classList.remove('cm-variant-dropdown__item--selected');
        item.setAttribute('aria-selected', 'false');
        if (check_el) check_el.classList.add('cm-variant-dropdown__check--hidden');
      }
    });

    // summaryテキストの更新
    const summary_text = summary_el.querySelector('.cm-variant-dropdown__summary-text');
    if (summary_text) {
      summary_text.textContent = value;
    }

    // summary画像の更新（カラーオプションの場合）
    const summary_img = summary_el.querySelector('.cm-variant-dropdown__summary-image');
    const item_img = selected_item.querySelector('.cm-variant-dropdown__image');
    if (summary_img && item_img) {
      summary_img.src = item_img.src;
      summary_img.alt = value;
    }

    // ドロップダウンを閉じる
    details_el.removeAttribute('open');

    // カスタムイベントを発火
    const custom_event = new CustomEvent('cm-variant-dropdown:change', {
      bubbles: true,
      detail: {
        value: value,
        variantId: variant_id,
        available: is_available,
        optionName: dropdown_el.dataset.optionName,
        optionIndex: parseInt(dropdown_el.dataset.optionIndex, 10)
      }
    });
    dropdown_el.dispatchEvent(custom_event);
  }

  /**
   * 外部からドロップダウンの値をプログラム的に設定
   * @param {HTMLElement} dropdown_el - .cm-variant-dropdown 要素
   * @param {string} value - 設定する値
   */
  function setDropdownValue(dropdown_el, value) {
    const summary_el = dropdown_el.querySelector('.cm-variant-dropdown__summary');
    const items = dropdown_el.querySelectorAll('.cm-variant-dropdown__item');

    items.forEach(function (item) {
      const check_el = item.querySelector('.cm-variant-dropdown__check');
      if (item.dataset.value === value) {
        item.classList.add('cm-variant-dropdown__item--selected');
        item.setAttribute('aria-selected', 'true');
        if (check_el) check_el.classList.remove('cm-variant-dropdown__check--hidden');

        // summaryの更新
        const summary_text = summary_el.querySelector('.cm-variant-dropdown__summary-text');
        if (summary_text) summary_text.textContent = value;

        const summary_img = summary_el.querySelector('.cm-variant-dropdown__summary-image');
        const item_img = item.querySelector('.cm-variant-dropdown__image');
        if (summary_img && item_img) {
          summary_img.src = item_img.src;
          summary_img.alt = value;
        }
      } else {
        item.classList.remove('cm-variant-dropdown__item--selected');
        item.setAttribute('aria-selected', 'false');
        if (check_el) check_el.classList.add('cm-variant-dropdown__check--hidden');
      }
    });
  }

  // グローバルに公開（外部JSから利用可能にする）
  window.CmVariantDropdown = {
    init: initDropdown,
    setValue: setDropdownValue
  };

  // ページ内の全ドロップダウンを初期化
  document.querySelectorAll('.cm-variant-dropdown').forEach(initDropdown);
})();
